import { DataTableCol } from "../../../components/tables/types";

export const ResultListDataGridCols: DataTableCol[] = [
    {
        title: "Date",
        control: "createdAt",
        sortable: true,
        canShowColumn: true,
      },
      {
        title: "Name",
        control: "name",
        sortable: true,
        canShowColumn: true,
      },
      {
        title: "Email",
        control: "emailAddress",
        sortable: true,
        canShowColumn: true,
      },
      {
        title: "Phone Number",
        control: "contactNumber",
        sortable: true,
        canShowColumn: true,
      },
      {
        title: "College",
        control: "collegeName",
        sortable: true,
        canShowColumn: true,
      },
      {
        title: "Degree Year",
        control: "degreeYear",
        sortable: true,
        canShowColumn: true,
      },
      {
        title: "Score",
        control: "score",
        sortable: true,
        canShowColumn: true,
      },
    {
        title: 'Actions',
        control: 'both',
        sortable: false,
        isEdit: false,
        isDelete: true,
        canShowColumn: true
    },
];